export const testimonialsData = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Small Business Owner',
    image: 'https://public.readdy.ai/ai/img_res/4044c3bd80e0a46dc643dbafa2121c2e.jpg',
    quote: 'They saved me thousands in taxes! Their strategic planning approach helped my business reduce tax liability by 35% while staying fully compliant. The team is knowledgeable, responsive, and truly cares about their clients success.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Real Estate Investor',
    image: 'https://readdy.ai/api/search-image?query=asian%20businessman%20professional%20headshot%20smiling%20in%20business%20attire%20modern%20office%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial2&orientation=squarish',
    quote: 'After years of doing my own taxes, I finally hired professionals and wish I had done it sooner. They found deductions I never knew existed and their audit support gave me complete peace of mind.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    role: 'Healthcare Professional',
    image: 'https://readdy.ai/api/search-image?query=latina%20professional%20woman%20doctor%20smiling%20warmly%20in%20medical%20office%20setting%20natural%20lighting%20professional%20headshot%20corporate%20style%20photography&width=400&height=400&seq=testimonial3&orientation=squarish',
    quote: 'The quarterly consulting service has been invaluable for managing my practice finances. They help me stay organized throughout the year and tax season is now stress-free. Highly recommend their services!',
    rating: 5,
  },
  {
    id: 4,
    name: 'David Thompson',
    role: 'Freelance Consultant',
    image: 'https://readdy.ai/api/search-image?query=professional%20man%20consultant%20smiling%20confidently%20in%20modern%20workspace%20natural%20lighting%20business%20casual%20attire%20corporate%20headshot%20photography%20style&width=400&height=400&seq=testimonial4&orientation=squarish',
    quote: 'As a freelancer with multiple income streams, my taxes were complicated. This team made everything simple and maximized my deductions. Their client portal makes document sharing effortless.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    role: 'Retail Store Owner',
    image: 'https://readdy.ai/api/search-image?query=professional%20woman%20retail%20business%20owner%20smiling%20warmly%20in%20boutique%20store%20setting%20natural%20lighting%20entrepreneur%20corporate%20headshot%20style%20photography&width=400&height=400&seq=testimonial5&orientation=squarish',
    quote: 'When I faced an IRS audit, they represented me with expertise and professionalism. The audit was resolved quickly in my favor. I trust them completely with all my tax needs.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Robert Williams',
    role: 'Manufacturing Executive',
    image: 'https://readdy.ai/api/search-image?query=professional%20executive%20man%20smiling%20confidently%20in%20industrial%20office%20setting%20natural%20lighting%20business%20suit%20corporate%20headshot%20photography%20style&width=400&height=400&seq=testimonial6&orientation=squarish',
    quote: 'Their business tax planning strategies have been instrumental in our company growth. They understand the complexities of manufacturing and provide tailored solutions that deliver real results.',
    rating: 5,
  },
];
